export function createStore(initial) {
    let value = initial;
    const listeners = new Set();
    return {
        get: () => value,
        set(next) {
            value = next;
            listeners.forEach((l) => l());
        },
        subscribe(l) {
            listeners.add(l);
            return () => void listeners.delete(l);
        },
    };
}
//# sourceMappingURL=store.js.map